// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconPipeline.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconPipeline = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M16 8.64H14.6947V15.1326H16V8.64Z" />
    <path d="M14.2737 7.78105H12.1011V16H14.2737V7.78105Z" />
    <path d="M11.68 8.64V15.1326H10.1642C5.03579 15.1326 0.867368 10.9642 0.867368 5.83579V4.32H7.36V5.83579C7.36 7.38526 8.61474 8.64 10.1642 8.64H11.68Z" />
    <path d="M8.21895 1.72632H0V3.89895H8.21895V1.72632Z" />
    <path d="M7.36 0H0.867368V1.30526H7.36V0Z" />
  </BaseIcon>
);

export default IconPipeline;
